import { range } from 'lodash';
import moment from 'moment-timezone';

import { NAME as contactsQuery } from '../Contacts/withContacts/contactsQuery';
import { scheduleDayGql } from './withCalendarEvents';

/**
 * @param {string} dealerId The dealer ID
 * @param {string} day The day to fetch, in YYYY-MM-DD format
 * @return {Object}
 */
const buildRefetchScheduleQuery = (dealerId, day) => ({
  query: scheduleDayGql,
  variables: { dealerId, day },
  fetchPolicy: 'network-only',
});

/**
 * Return the refetch queries needed for the overall dealer detail page
 * upon change to any after-hours rotation event (create, edit, or delete).
 *
 * @param {Moment|string} startDate - start date of the modified event
 * @param {string} dealerId - ID of the current dealer
 * @return {Array} - an array of refetch queries
 */
export default function scheduleChangeRefetch(startDate, dealerId) {
  // Refreshing all of the days of the currently-displayed week will
  // avoid some super complicated start/end/overlap calculations.
  // It will only be a performance hit until query batching is in place.

  const startOfWeek = moment(startDate).startOf('isoWeek'); // isoWeek: 1=Mon, 7=Sun

  const scheduleQueries = range(1, 8).map(index =>
    buildRefetchScheduleQuery(
      dealerId,
      startOfWeek.isoWeekday(index).format('YYYY-MM-DD'),
    ),
  );

  // A contact changes to non-deletable when it is first used in a rotation. Including the
  // contacts query here refreshes the contacts panel's data & updates the display.
  return [contactsQuery].concat(scheduleQueries);
}



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/scheduleChangeRefetch.js